import AuthenticatedClient from '@/repositories/clients/AuthenticatedClient';
import { useUrl } from '@/utils/url';

const url = useUrl('../v1/alerts');

export default {
  options(config = {}) {
    return AuthenticatedClient.get(url('options'), config);
  },
  /**
   * `config` is merged into the axios request config. Passive callers (Home /
   * Mijn-omgeving cards) pass `{ suppressEntitlementModal: true }` so a 403
   * `entitlement_missing` does not open the global upgrade modal.
   */
  list(params, config = {}) {
    return AuthenticatedClient.get(url(), { ...config, params });
  },
  store(data) {
    return AuthenticatedClient.post(url(), data);
  },
  show(id) {
    return AuthenticatedClient.get(url(id));
  },
  update(id, data) {
    return AuthenticatedClient.put(url(id), data);
  },
  destroy(id) {
    return AuthenticatedClient.delete(url(id));
  },
  history(id, params) {
    return AuthenticatedClient.get(url(`${id}/history`), { params });
  },
  exportHistory(id, params) {
    return AuthenticatedClient.get(url(`${id}/history/export`), {
      params,
      responseType: 'blob',
    });
  },
  testEvaluate(id) {
    return AuthenticatedClient.post(url(`${id}/test-evaluate`));
  },
  testEvaluateResult(taskId) {
    return AuthenticatedClient.get(url(`test-evaluate/${taskId}/result`));
  },
  templates() {
    return AuthenticatedClient.get(url('templates'));
  },
  /** One request for a page of alerts: `{ days, stats: { [id]: {...counts} } }`. */
  statsBatch(ids, params) {
    return AuthenticatedClient.get(url('stats'), { params: { ids: ids.join(','), ...params } });
  },
  listEnabledTargets() {
    return AuthenticatedClient.get(url('target-registry/enabled'));
  },
  testNotify(alertId) {
    return AuthenticatedClient.post(url(`${alertId}/test-notify`));
  },
};
